import { 
  GetCustomerFwAddresses,
  CreateCustomerFwAddress,
  UpdateCustomerFwAddress,
  RemoveCustomerFwAddress,
  GetCustomerActivity,
  GetCustomerReceptionistList,
  SubscribeCustomerToLiveReceptionist,
  UnsubscribeCustomerFromLiveReceptionist,
  GetCustomerPhoneList,
  GetCustomerPhoneUsage,
  GetCustomerCharges,
  MakeCustomerCharge,
  CancelCustomerCharge,
  RefundCustomerCharge,
  GetCustomerOutgoing,
  AddCustomerOutgoing,
  UpdateCustomerOutgoing,
  DeleteCustomerOutgoing,
  GetCustomerPhoneExtensions,
  CreateCustomerPhoneExtension,
  UpdateCustomerPhoneExtension,
  RemoveCustomerPhoneExtension,
  UpdateCustomerPhoneNumber,
  DeleteCustomerPhoneNumber,
  SearchCustomerPhoneNumbers,
  BuyCustomerPhoneNumber,
  GetCustomerPhone,
  GetCustomerPhonePorting,
  SendCustomerPhonePorting,
  PerformCustomCustomerAction,
  PerformCustomerSmsServiceAction,
  GetCustomerJointAccounts,
  AddCustomerJointAccount,
  UpdateCustomerJointAccount,
  RemoveCustomerJointAccount,
  GetAllCustomerCardsInfo,
  CustomerAddCard,
  CustomerUpdateCard,
  CustomerDeleteCard,
  CustomerUpgradePlan,
  GetCustomerNotarizePackages,
  CreateCustomerNotarizePackage,
  ConfirmCustomerNotarizePackage,
  CancelCustomerNotarizePackage,
  GetCustomerBankAccount,
  AddCustomerBankAccount,
  SetCustomerBankDefault,
  DeleteCustomerBankAccount,
  GetCustomerLinkToken,
  GetCustomerLiveRecipients,
  AddCustomerLiveRecipient,
  UpdateCustomerLiveRecipient,
  DeleteCustomerLiveRecipient,
  GetCustomerBalanceAdjustments,
  AdjustCustomerBalance
} from '@/api/wrappers';

// eslint-disable-next-line import/no-cycle

export const getForwardingAddresses = ({dispatch}, id) => dispatch('CheckAuth', null, {root: true})
  .then(() => GetCustomerFwAddresses(id)
    .then(res => {
      return res;
    })
  )
  .catch((e) => {
    console.log(e);
  });

export const createForwardAddress = ({dispatch}, data) => dispatch('CheckAuth', null, {root: true})
  .then(() => CreateCustomerFwAddress(data)
    .then(res => {
      return res;
    })
  )
  .catch((e) => {
    console.log(e);
  });

export const updateForwardAddress = ({dispatch}, data) => dispatch('CheckAuth', null, {root: true})
  .then(() => UpdateCustomerFwAddress(data)
    .then(res => {
      return res;
    })
  )
  .catch(e => new Promise((resolve, reject) => {
    reject(e);
  }));

export const removeCustomerFwAddress = ({dispatch}, data) => dispatch('CheckAuth', null, {root: true})
  .then(() => RemoveCustomerFwAddress(data)
    .then(res => {
      return res;
    })
  )
  .catch(e => new Promise((resolve, reject) => {
    reject(e);
  }));

export const getCustomerActivity = ({dispatch}, id) => dispatch('CheckAuth', null, {root: true})
  .then(() => GetCustomerActivity(id)
    .then(res => {
      return res;
    })
  )
  .catch((e) => {
    console.log(e);
  });

export const getCustomerReceptionistList = ({dispatch}) => dispatch('CheckAuth', null, {root: true})
  .then(() => GetCustomerReceptionistList()
    .then(res => {
      return res;
    })
  )
  .catch((e) => {
    console.log(e);
  });

export const subCustomerToReceptionist = ({commit, dispatch}, data) => dispatch('CheckAuth', null, {root: true})
  .then(() => SubscribeCustomerToLiveReceptionist(data)
    .then((res) => res)
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  )

export const unsubCustomerFromReceptionist = ({commit, dispatch}, id) => dispatch('CheckAuth', null, {root: true})
  .then(() => UnsubscribeCustomerFromLiveReceptionist(id)
    .then((res) => res)
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  )

export const getCustomerPhoneList = ({dispatch}, id) => dispatch('CheckAuth', null, {root: true})
  .then(() => GetCustomerPhoneList(id)
    .then(res => {
      return res;
    })
  )
  .catch((e) => {
    console.log(e);
  });

export const getCustomerPhoneUsage = ({dispatch}, id) => dispatch('CheckAuth', null, {root: true})
  .then(() => GetCustomerPhoneUsage(id)
    .then(res => {
      return res;
    })
  )
  .catch((e) => {
    console.log(e);
  });

export const getCustomerCharges = ({dispatch}, data) => dispatch('CheckAuth', null, {root: true})
  .then(() => GetCustomerCharges(data)
    .then(res => {
      return res;
    })
  )
  .catch((e) => {
    console.log(e);
  });

export const makeCustomerCharge = ({dispatch}, data) => dispatch('CheckAuth', null, {root: true})
  .then(() => MakeCustomerCharge(data)
    .then(res => {
      return res;
    })
  )
  .catch(e => new Promise((resolve, reject) => {
    reject(e);
  }))

export const cancelCustomerCharge = ({dispatch}, data) => dispatch('CheckAuth', null, {root: true})
  .then(() => CancelCustomerCharge(data)
    .then(res => {
      return res;
    })
  )
  .catch((e) => {
    console.log(e);
  });

export const refundCustomerCharge = ({dispatch}, data) => dispatch('CheckAuth', null, {root: true})
  .then(() => RefundCustomerCharge(data)
    .then(res => {
      return res;
    })
  )
  .catch((e) => {
    console.log(e);
  });

export const getCustomerOutgoingNumbers = ({dispatch}, data) => dispatch('CheckAuth', null, {root: true})
  .then(() => GetCustomerOutgoing(data)
    .then((res) => res)
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  )

export const addCustomerOutgoingNumber = ({dispatch}, data) => dispatch('CheckAuth', null, {root: true})
  .then(() => AddCustomerOutgoing(data)
    .then((res)=> res)
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  )

export const updateCustomerOutgoingNumber = ({dispatch}, data) => dispatch('CheckAuth', null, {root: true})
  .then(() => UpdateCustomerOutgoing(data)
    .then((res)=> res)
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  )

export const deleteCustomerOutgoingNumber = ({dispatch}, data) => dispatch('CheckAuth', null, {root: true})
  .then(() => DeleteCustomerOutgoing(data)
    .then((res) => res)
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  )

export const getCustomerExtensions = ({dispatch}, data) => dispatch('CheckAuth', null, {root: true})
  .then(() => GetCustomerPhoneExtensions(data)
    .then((res) => res)
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  )

export const createCustomerExtension = ({dispatch}, data) => dispatch('CheckAuth', null, {root: true})
  .then(() => CreateCustomerPhoneExtension(data)
    .then((res) => res)
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  )

export const updateCustomerExtension = ({dispatch}, data) => dispatch('CheckAuth', null, {root: true})
  .then(() => UpdateCustomerPhoneExtension(data)
    .then((res) => res)
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  )

export const removeCustomerExtension = ({dispatch}, data) => dispatch('CheckAuth', null, {root: true})
  .then(() => RemoveCustomerPhoneExtension(data)
    .then((res) => res)
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  )

export const updateCustomerNumber = ({dispatch}, data) => dispatch('CheckAuth', null, {root: true})
  .then(() => UpdateCustomerPhoneNumber(data)
    .then((res) => res)
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  )

export const deleteCustomerNumber = ({dispatch}, data) => dispatch('CheckAuth', null, {root: true})
  .then(() => DeleteCustomerPhoneNumber(data)
    .then((res) => res)
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  )

export const getCustomerAvailablePhones = ({dispatch}, data) => dispatch('CheckAuth', null, {root: true})
  .then(() => SearchCustomerPhoneNumbers(data)
    .then((res) => res)
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  )

export const buyCustomerNumber = ({dispatch}, data) => dispatch('CheckAuth', null, {root: true})
  .then(() => BuyCustomerPhoneNumber(data)
    .then((res) => res)
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  )

export const getCustomerPhoneNumber = ({dispatch}, data) => dispatch('CheckAuth', null, {root: true})
  .then(() => GetCustomerPhone(data)
    .then((res) => {
      return res.phone_number;
    })
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  )

export const getCustomerPortRequest = ({dispatch}, id) => dispatch('CheckAuth', null, {root: true})
  .then(() => GetCustomerPhonePorting(id)
    .then((res) => res)
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  )

export const sendCustomerPortRequest = ({dispatch}, data) => dispatch('CheckAuth', null, {root: true})
  .then(() => SendCustomerPhonePorting(data)
    .then((res) => res)
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  )

export const customCustomerAction = ({dispatch}, data) => dispatch('CheckAuth', null, {root: true})
  .then(() => PerformCustomCustomerAction(data)
    .then(() => dispatch('customers/getCustomer', data.id, {root:true})
      .then((res) => {
        return res;
      })
      .catch(e => new Promise((resolve, reject) => {
        reject(e);
      }))
    )
  );

export const customerSmsServiceAction = ({dispatch}, data) => dispatch('CheckAuth', null, {root: true})
  .then(() => PerformCustomerSmsServiceAction(data)
    .then((res) => {
      return res;
    })
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  )

export const getCustomerRecipients = ({dispatch}, id) => dispatch('CheckAuth', null, {root: true})
  .then(() => GetCustomerJointAccounts(id)
    .then((list) => {
      return list;
    })
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  )

export const addCustomerRecipient = ({dispatch}, data) => dispatch('CheckAuth', null, {root: true})
  .then(() => AddCustomerJointAccount(data)
    .then((res) => {
      return res;
    })
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  )

export const updateCustomerRecipient = ({dispatch}, data) => dispatch('CheckAuth', null, {root: true})
  .then(() => UpdateCustomerJointAccount(data)
    .then((res) => {
      return res;
    })
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  )

export const removeCustomerRecipient = ({dispatch}, data) => dispatch('CheckAuth', null, {root: true})
  .then(() => RemoveCustomerJointAccount(data)
    .then(res => {
      return res;
    })
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  )

export const getAllCustomerCards = ({ dispatch }, id) => dispatch('CheckAuth', null, {root: true})
  .then(() => GetAllCustomerCardsInfo(id)
    .then((res) => {
      return res;
    })
  );

export const customerAddCard = ({ dispatch }, data) => dispatch('CheckAuth', null, {root: true})
  .then(() => CustomerAddCard(data)
    .then((res) => {
      return res;
    })
  );

export const customerUpdateCard = ({ dispatch }, data) => dispatch('CheckAuth', null, {root: true})
  .then(() => CustomerUpdateCard(data)
    .then((res) => {
      return res;
    })
  );

export const customerDeleteCard = ({ dispatch }, data) => dispatch('CheckAuth', null, {root: true})
  .then(() => CustomerDeleteCard(data)
    .then((res) => {
      return res;
    })
  );

export const customerUpgradePlan = ({ dispatch }, data) => dispatch('CheckAuth', null, {root: true})
  .then(() => CustomerUpgradePlan(data)
    .then((res) => {
      return res;
    })
  );

export const getCustomerAllNotarize = ({dispatch}, id) => dispatch('CheckAuth', null, {root: true})
  .then(() => GetCustomerNotarizePackages(id)
    .then(res => {
      return res;
    })
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  )

export const createCustomerNotarize = ({dispatch}, data) => dispatch('CheckAuth', null, {root: true})
  .then(() => CreateCustomerNotarizePackage(data)
    .then(res => {
      return res;
    })
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  )

export const confirmCustomerNotarize = ({dispatch}, data) => dispatch('CheckAuth', null, {root: true})
.then(() => ConfirmCustomerNotarizePackage(data)
  .then(res => {
    return res;
  })
  .catch(e => new Promise((resolve, reject) => {
    reject(e);
  }))
)

export const cancelCustomerNotarize = ({dispatch}, data) => dispatch('CheckAuth', null, {root: true})
  .then(() => CancelCustomerNotarizePackage(data)
    .then(res => {
      return res;
    })
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  )

export const getCustomerBankAccount = ({dispatch}, id) => dispatch('CheckAuth', null, {root: true})
  .then(() => GetCustomerBankAccount(id)
    .then(res => {
      return res;
    })
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  )

export const addCustomerBankAccount = ({dispatch}, data) => dispatch('CheckAuth', null, {root: true})
  .then(() => AddCustomerBankAccount(data)
    .then(res => {
      return res;
    })
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  )

export const setCustomerBankDefault = ({dispatch}, id) => dispatch('CheckAuth', null, {root: true})
  .then(() => SetCustomerBankDefault(id)
    .then(res => {
      return res;
    })
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  )

export const deleteCustomerBankAccount = ({dispatch}, id) => dispatch('CheckAuth', null, {root: true})
  .then(() => DeleteCustomerBankAccount(id)
    .then(res => {
      return res;
    })
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  )

export const getCustomerLinkToken = ({dispatch}, id) => dispatch('CheckAuth', null, {root: true})
  .then(() => GetCustomerLinkToken(id)
    .then(res => {
      return res;
    })
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  )

export const getCustomerLiveRecipients = ({dispatch}, id) => dispatch('CheckAuth', null, {root: true})
  .then(() => GetCustomerLiveRecipients(id)
    .then((res) => {
      return res;
    })
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  )

export const addCustomerLiveRecipient = ({dispatch}, data) => dispatch('CheckAuth', null, {root: true})
  .then(() => AddCustomerLiveRecipient(data)
    .then((res) => {
      return res;
    })
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  )

export const updateCustomerLiveRecipient = ({dispatch}, data) => dispatch('CheckAuth', null, {root: true})
  .then(() => UpdateCustomerLiveRecipient(data)
    .then((res) => {
      return res;
    })
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  )

export const deleteCustomerLiveRecipient = ({dispatch}, data) => dispatch('CheckAuth', null, {root: true})
  .then(() => DeleteCustomerLiveRecipient(data)
    .then((res) => {
      return res;
    })
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  )

export const getCustomerBalanceAdjustments = ({dispatch}, data) => dispatch('CheckAuth', null, {root: true})
  .then(() => GetCustomerBalanceAdjustments(data)
    .then((res) => {
      return res;
    })
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  )

export const adjustCustomerBalance = ({dispatch}, data) => dispatch('CheckAuth', null, {root: true})
  .then(() => AdjustCustomerBalance(data)
    .then((res) => {
      return res;
    })
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  )